{
  "tabs": {
    "chat": "Chat",
    "reminders": "Eslatmalar",
    "calendar": "Taqvim",
    "settings": "Sozlamalar"
  },
  "common": {
    "cancel": "Bekor qilish",
    "save": "Saqlash",
    "confirm": "Tasdiqlash",
    "delete": "O'chirish",
    "back": "Orqaga",
    "close": "Yopish",
    "edit": "Tahrirlash",
    "search": "Qidirish",
    "all": "Hammasi",
    "loading": "Yuklanmoqda...",
    "error": "Xatolik yuz berdi",
    "notFound": "Topilmadi",
    "tryAgain": "Iltimos, qayta urinib ko'ring",
    "retry": "Qayta urinish",
    "undo": "Bekor qilish",
    "pullToRefresh": "Yangilash uchun torting",
    "justNow": "hozirgina"
  },
  "auth": {
    "welcome": "FishMemory ga xush kelibsiz",
    "tagline": "Sizning WhatsApp eslatma yordamchingiz, endi cho'ntagingizda.",
    "subtitle": "Sizning WhatsApp eslatma yordamchingiz, endi cho'ntagingizda.",
    "phoneLabel": "Sizning WhatsApp raqamingiz",
    "phoneHint": "Tasdiqlash kodi WhatsApp orqali yuboriladi",
    "invalidPhone": "Iltimos, to'g'ri telefon raqamini kiriting",
    "continue": "Davom etish",
    "enterPhone": "WhatsApp raqamingizni kiriting",
    "phonePlaceholder": "Telefon raqami",
    "sendCode": "Kod yuborish",
    "verifyTitle": "Raqamingizni tasdiqlang",
    "otpSentTo": "6 xonali kod {{phone}} ga WhatsApp orqali yuborildi",
    "enterFullCode": "Iltimos, barcha 6 raqamni kiriting",
    "invalidOtp": "Noto'g'ri kod. Iltimos, qayta urinib ko'ring.",
    "otpFailed": "Kod yuborilmadi. Qayta urinib ko'ring.",
    "otpResent": "Kod qayta yuborildi",
    "resendIn": "{{seconds}}s ichida qayta yuborish",
    "resendCode": "Kod qayta yuborish",
    "enterOtp": "WhatsApp ga yuborilgan kodni kiriting",
    "verify": "Tasdiqlash",
    "resend": "Kod qayta yuborish",
    "wrongNumber": "Noto'g'ri raqam?",
    "backToPhone": "Telefon raqamga qaytish",
    "editPhone": "Telefon raqamini tahrirlash",
    "error": "Xatolik",
    "setupTitle": "Sozlamalarni boshlaymiz",
    "setupSubtitle": "Bularni keyin Sozlamalarda o'zgartirishingiz mumkin",
    "namePlaceholder": "Ismingiz",
    "letsGo": "Sozlamani yakunlash",
    "skipForNow": "Hozircha o'tkazib yuborish"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Xabar yozing...",
    "inputPlaceholder": "Xabar yozing...",
    "typing": "FishMemory yozmoqda...",
    "online": "Onlayn",
    "connecting": "Ulanmoqda...",
    "reconnecting": "Qayta ulanmoqda...",
    "offline": "Oflayn",
    "empty": "Suhbatni boshlang",
    "emptyHint": "Eslatmalar yarating, jadvalingizni tekshiring yoki yordam so'rang.",
    "emptyAction": "Namuna eslatma yuborish",
    "actions": "Suhbat harakatlari",
    "keep": "Xabarlarni saqlash",
    "clearTitle": "Suhbatni tozalash",
    "clearConfirm": "Ushbu qurilmadagi barcha xabarlarni o'chirmoqchimisiz? Bu qaytarib bo'lmaydi.",
    "clear": "Suhbatni tozalash",
    "optionSelected": "Tanlandi: {{label}}",
    "sendingSelection": "Yuborilmoqda...",
    "connectionLost": "Qayta ulanmoqda..."
  },
  "reminders": {
    "title": "Mening eslatmalarim",
    "active": "Faol",
    "today": "Bugun",
    "thisWeek": "Bu hafta",
    "history": "Tarix",
    "items": "elementlar",
    "emptyTitle": "Hali eslatmalar yo'q",
    "emptySubtitle": "Suhbatdan yarating, u bu yerda ko'rinadi.",
    "emptyAction": "Suhbatni ochish",
    "filterActive": "Faol",
    "filterToday": "Bugun",
    "filterWeek": "Bu hafta",
    "filterHistory": "Tarix",
    "emptyState": "Hali eslatmalar yo'q. Suhbatni boshlang!",
    "swipeDone": "Bajarildi",
    "swipeSnooze": "Keyinga surish",
    "swipeDelete": "O'chirish",
    "search": "Eslatmalarni qidirish...",
    "upcoming": "Yaqinlashmoqda",
    "completed": "Bajarilgan",
    "overdue": "Kechikkan",
    "tomorrow": "Ertaga",
    "synced": "Sinxronlandi {{value}}",
    "swipeHint": "Qo'shimcha harakatlar uchun eslatmani suring",
    "noResults": "Qidiruvga mos eslatma topilmadi",
    "noResultsHint": "Boshqa kalit so'z sinab ko'ring yoki qidiruvni tozalang",
    "deleteAllFailed": "Barcha eslatmalarni o'chirish muvaffaqiyatsiz tugadi"
  },
  "calendar": {
    "title": "Taqvim",
    "today": "Bugun",
    "tomorrow": "Ertaga",
    "completed": "bajarildi",
    "noEvents": "Reja yo'q",
    "noEventsSubtitle": "Eslatmalar va taqvim voqealarini ko'rish uchun sanani tanlang.",
    "googleEvent": "Google Taqvim",
    "legendActive": "Faol",
    "legendRecurring": "Takrorlanuvchi",
    "legendDone": "Bajarilgan",
    "legendGoogle": "Google",
    "previousMonth": "O'tgan oy",
    "nextMonth": "Keyingi oy",
    "previousYear": "O'tgan yil",
    "nextYear": "Keyingi yil",
    "goToToday": "Bugunga o'tish",
    "all": "Hammasi",
    "active": "Faol",
    "done": "Bajarilgan",
    "paused": "To'xtatilgan"
  },
  "settings": {
    "title": "Sozlamalar",
    "profile": "Profil",
    "name": "Ko'rsatish nomi",
    "enterName": "Ismingizni kiriting",
    "language": "Til",
    "uiLanguage": "Ilova tili",
    "uiLanguageHelp": "Faqat ushbu qurilmada ilova interfeysi, taqvim yorliqlari va tartibini o'zgartiradi.",
    "serverLanguage": "Suhbat tili",
    "serverLanguageHelp": "Hisobingiz uchun server javoblari va eslatma xabarlarida ishlatiladigan tilni o'zgartiradi.",
    "timezone": "Vaqt zonasi",
    "currentTimezone": "Joriy vaqt zonasi",
    "timezoneHelp": "Barcha eslatma vaqtlar ushbu vaqt zonasida ko'rsatiladi.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Vaqt zonasini saqlash",
    "timezoneSaved": "Vaqt zonasi yangilandi",
    "detect": "Aniqlash",
    "detectFailed": "Vaqt zonasi aniqlanmadi",
    "autoDetect": "GPS orqali avtomatik aniqlash",
    "notifications": "Bildirishnomalar",
    "notificationsHelp": "Qayta eslatmalar eslatma yetkazilgandan keyin takroriy ogohlantirishlarni boshqaradi. Qurilma darajasidagi bildirishnoma ruxsatlari telefon sozlamalarida boshqariladi.",
    "pushEnabled": "Push bildirishnomalari",
    "autoDoneOnFire": "Yoqilganda avtomatik bajarilgan deb belgilash",
    "autoDoneOnFireDesc": "O'chirilganida, eslatmalar faolligicha qoladi, siz ularni bajarilgan deb belgilamaguningizcha.",
    "googleCalendar": "Google Taqvim",
    "google": "Google Taqvim",
    "googleConnected": "Ulangan",
    "googleDisconnected": "Ulanmagan",
    "googleConnectedHelp": "Yangi eslatmalar avtomatik ravishda taqvimga sinxronlanishi mumkin.",
    "googleDisconnectedHelp": "Google Taqvimni ulang, eslatmalar va voqealarni moslashtirish uchun.",
    "googleConnectFailed": "Google Taqvimga ulanish muvaffaqiyatsiz tugadi",
    "connected": "Ulangan",
    "disconnected": "Ulanmagan",
    "connect": "Ulash",
    "disconnect": "Ulanishni uzish",
    "autoSync": "Yangi eslatmalarni avtomatik sinxronlash",
    "autosync": "Yangi eslatmalarni avtomatik sinxronlash",
    "subscription": "Obuna",
    "trialUsed": "Sinov: {{used}}/{{total}} ishlatildi",
    "trialStatus": "Sinov mavjud",
    "activeStatus": "Faol obuna",
    "expiredStatus": "Obuna muddati tugagan",
    "unsubscribedStatus": "Obuna emas",
    "about": "Haqida",
    "version": "Versiya",
    "logout": "Chiqish",
    "logoutTitle": "Chiqish",
    "logoutConfirm": "Chiqishni xohlaysizmi?",
    "noName": "Ism belgilanmagan",
    "serverConnection": "Server ulanishi",
    "serverUrl": "Server URL",
    "serverEdit": "Tahrirlash",
    "saveReconnect": "Saqlash va qayta ulanish",
    "resetDefault": "Standartga qaytarish",
    "invalidServerUrlTitle": "Noto'g'ri server URL",
    "invalidServerUrlMessage": "To'g'ri http yoki https server URL kiriting, masalan https://example.com",
    "uiLanguageChangeFailed": "Ilova tilini o'zgartirish muvaffaqiyatsiz. Iltimos, qayta urinib ko'ring.",
    "serverLanguageChangeFailed": "Suhbat tilini o'zgartirish muvaffaqiyatsiz. Iltimos, qayta urinib ko'ring.",
    "timezoneChangeFailed": "Vaqt zonasini o'zgartirish muvaffaqiyatsiz. Iltimos, qayta urinib ko'ring.",
    "autoSyncChangeFailed": "Avtomatik sinxronlashni yangilash muvaffaqiyatsiz. Iltimos, qayta urinib ko'ring.",
    "nameChangeFailed": "Ko'rsatish nomini yangilash muvaffaqiyatsiz. Iltimos, qayta urinib ko'ring.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Eslatma tafsilotlari",
    "editTime": "Vaqtni tahrirlash",
    "rename": "Nomini o'zgartirish",
    "snooze": "Keyinga surish",
    "snooze15": "15 daqiqaga keyinga surish",
    "pause": "To'xtatish",
    "pauseReminder": "Eslatmani to'xtatish",
    "resume": "Davom ettirish",
    "resumeReminder": "Eslatmani davom ettirish",
    "skip": "Keyingisini o'tkazib yuborish",
    "skipOccurrence": "Ushbu takrorlashni o'tkazib yuborish",
    "syncGoogle": "Google bilan sinxronlash",
    "delete": "O'chirish",
    "deleteTitle": "Eslatmani o'chirish",
    "deleteConfirm": "Ushbu eslatma doimiy o'chiriladi.",
    "deleteRecurringTitle": "Takrorlanuvchi eslatmani o'chirish",
    "deleteRecurringMessage": "Ushbu takrorlashni o'tkazib yubormoqchimisiz yoki butun seriyani o'chirmoqchimisiz?",
    "deleteThisOccurrence": "Ushbu takrorlashni o'tkazib yuborish",
    "deleteEntireSeries": "Butun seriyani o'chirish",
    "done": "Bajarildi",
    "markDone": "Bajarilgan deb belgilash",
    "undo": "Qaytarish",
    "undoPrompt": "Yana faol bo'lishini xohlaysizmi? Hozir tiklang.",
    "recurring": "Takrorlanuvchi",
    "nextRun": "Keyingi ishga tushirish",
    "oneTime": "Bir martalik",
    "pending": "Kutilmoqda",
    "sent": "Yuborilgan",
    "paused": "To'xtatilgan",
    "active": "Faol",
    "snoozed": "Keyinga surilgan",
    "localTime": "Mahalliy vaqtingizda ko'rsatilgan",
    "recurrence": "Takrorlanish",
    "created": "Yaratilgan",
    "tags": "Teglar",
    "fireCount": "Ishga tushirishlar soni",
    "actions": "Harakatlar",
    "none": "Yo'q",
    "snoozeFailed": "Eslatmani keyinga surish muvaffaqiyatsiz",
    "pauseFailed": "Eslatmani to'xtatish muvaffaqiyatsiz",
    "resumeFailed": "Eslatmani davom ettirish muvaffaqiyatsiz",
    "skipFailed": "Eslatmani o'tkazib yuborish muvaffaqiyatsiz",
    "doneFailed": "Eslatmani bajarilgan deb belgilash muvaffaqiyatsiz",
    "undoFailed": "Eslatma holatini tiklash muvaffaqiyatsiz",
    "deleteFailed": "Eslatmani o'chirish muvaffaqiyatsiz",
    "rescheduleTitle": "Qayta rejalashtirish?",
    "rescheduleMsg": "Ushbu eslatma kechikkan. Uni qayta rejalashtirmoqchimisiz?",
    "reschedule15": "15 daqiqadan keyin",
    "reschedule60": "1 soatdan keyin",
    "keepOverdue": "Shunday qoldirish"
  },
  "onboarding": {
    "slide1Title": "FishMemory ga xush kelibsiz",
    "slide1Sub": "Sizning shaxsiy eslatma yordamchingiz — WhatsApp asosida va cho'ntagingiz uchun yaratilgan.",
    "slide2Title": "Faqat tabiiy suhbat qiling",
    "slide2Sub": "Eslatmalarni o'zingiz o'ylagancha yozing: “Ertaga soat 15:00 da onamga qo'ng'iroq qilishni eslat” — qolganini biz hal qilamiz.",
    "slide3Title": "Hech narsani o'tkazib yubormang",
    "slide3Sub": "O'z vaqtida bildirishnomalar oling, teglar bilan tartibga soling va muhim narsalarni nazorat qiling.",
    "getStarted": "Boshlash",
    "next": "Keyingi",
    "firstReminderTitle": "Birinchi eslatmangizni yarating!",
    "firstReminderHint": "Quyidagicha yozib ko'ring:",
    "firstReminderExample": "Ertaga soat 9:00 da suv ichishni eslat",
    "gotIt": "Tushundim!",
    "notifRationaleTitle": "Vaqtida qoling",
    "notifRationaleBody": "FishMemory sizga o'z vaqtida eslatish uchun bildirishnomalar kerak. Faqat yaratgan eslatmalaringiz uchun ogohlantirish olasiz.",
    "notifRationaleAllow": "Bildirishnomalarni yoqish",
    "notifRationaleLater": "Keyinroq",
    "swipeHint": "Tez harakatlar uchun o'ngga suring →",
    "calendarDragHint": "Kengaytirish uchun torting ↕"
  }
}
